// import { useAuth } from '@hooks/useAuth';
import { getUsuarios, getTipoUsuario, getUsuario, verifyAndActivate, userChagePlan, deleteUserData, changePlanVto } from "services/Usuarios";
import { useState } from "react";


const useUsers = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [response, setResponse] = useState([])
    const [error, setError] = useState(null)

    // Ok
    const fetchData = async (id = null, withReturn = false, type = null) => {
        setError(null)
        setIsLoading(true)

        try {
            let data;

            if (id) {
                data = await getUsuario(id)
                // setIsLoading(false)
            } else if (type) {
                data = await getTipoUsuario(type)
            } else {
                data = await getUsuarios()
            }

            if (withReturn) {
                setResponse(id ? data : data)

                setIsLoading(false)

                return id ? data[0] : data
            }

            setResponse(id ? data : data)
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }

    }

    const getInstituciones = async () => {
        const data = await fetchData(null, true)

        return data?.filter(user => user?.type === 'I')
    }

    const verifyAccount = async (id, payload) => {
        await verifyAndActivate(id, payload)
    }

    const changePlan = async (userId, planId) => {
        await userChagePlan(userId, planId)
    }

    const changeVtoPlan = async (data) => {
        await changePlanVto(data)
    }

    const deleteUser = async (userId) => {
        await deleteUserData(userId)
    }

    return { response, changePlan, isLoading, error, fetchData, verifyAccount, deleteUser, getInstituciones, changeVtoPlan }
}


export default useUsers